import React from "react";
import { Link } from "react-router-dom";
import AgentContracts from "../../components/agent-contracts";
import AgentCases from "../../components/agent-cases";
import { Provider } from 'react-redux'

import {
    HashRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";




class AgentMenu extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hash: ''
        }
    }

    componentDidMount() {
        this.setState({hash: window.location.hash})
    }


    render() {

        const hash = this.state.hash || "";
        const isStepActive = hash.startsWith("#/step");
        const isContractsActive = hash.startsWith("#/contracts");
        const isCasesActive = hash.startsWith("#/cases");

        var locationHashChanged = () => {
            this.setState({hash: window.location.hash})
          }
          
          window.onhashchange = locationHashChanged;

        return (
            <>
                <span className="xs-mr-20">{this.props.username}</span>
                { !this.props.signingOnly &&
                    <>
                        {!isStepActive && <a href={`/#/step/0`} className="xs-mr-10">Tilboðskerfi</a>}
                        {!isContractsActive && <a href={`/#/contracts`} className="xs-mr-10">Mínar umsóknir</a>}
                        {!isCasesActive && <a href={`/#/cases`} >Mín mál</a>}
                    </>
                }
            </>

        )
    }
}

AgentMenu.defaultProps = {
    signingOnly: false
}

export default AgentMenu
